module.exports = __webpack_public_path__ + "media/es_slide27_programa2.c886fea0.mp4";